// This function is used to load all the users' emails for a distribution location
// so emails can be sent.
import firebase from "../../../../components/Firebase.js";

export default async function LoadUserEmails(
  communityOrders,
  importedOrder,
  setLoadingEmails,
  setUserEmails,
  communityHubs,
) {
  const database = firebase.firestore();
  // This is a dictionary that will store the location of this user's ordering such as
  // an imported order. Then it will store the user along with the user's location
  // {firstName-lastName-userId : location}
  const users = {};
  // This stores the users location and their emails. {location : {firstName-lastName-userId : email}}
  const userEmailsTemp = {};
  // Cycle through all the communityOrders (there may be more than one order per person.)
  Object.keys(communityOrders).forEach((order) => {
    // Split up the order into an array [firstName, lastName, userId, dateOfOrder]
    const user = order.split("-");
    // Combine the firstName-lastName-userId
    const name = [user[0], user[1], user[2]].join("-");
    // Make sure that this user and its location are created
    users[name] = "Your Distribution Location";
    // Make sure that this location is created in the userEmails dictionary
    userEmailsTemp["Your Distribution Location"] = {};
  });

  // Cycle through the importedOrders first each location
  Object.keys(importedOrder).forEach((location, i) => {
    // Cycle through each of the communityOrders per location.
    Object.keys(importedOrder[location].communityOrders).forEach((order) => {
      // Split up the order into an array [firstName, lastName, userId, dateOfOrder]
      const user = order.split("-");
      // Combine the firstName-lastName-userId
      const name = [user[0], user[1], user[2]].join("-");
      // Make sure that this user and its location are created.
      users[name] = location;
      // Make sure that this location is created in the userEmails dictionary.
      userEmailsTemp[location] = {};
    });
  });

  // Cycle through the communityHubs locations for each location.
  Object.keys(communityHubs).forEach((location, i) => {
    // Cycle through each of the community hubs per location.
    Object.keys(communityHubs[location]).forEach((order) => {
      // Split up the order into an array [firstName, lastName, userId, dateOfOrder]
      const user = order.split("-");
      // Combine the firstName-lastName-userId
      const name = [user[0], user[1], user[2]].join("-");
      // Make sure that this user and its location are created.
      users[name] = location;
      // Make sure that this location is created in the userEmails dictionary.
      userEmailsTemp[location] = {};
    });
  });

  // Create a user keys to cycle through and set up the emails.
  const userKeys = Object.keys(users);
  if (userKeys.length === 0) {
    setUserEmails({ ...userEmailsTemp });
    return { ...userEmailsTemp };
  }
  // Set the loading emails to true while we load
  setLoadingEmails(true);

  // Cycle through all the newly created users.
  const promises = userKeys.map((userKey) => {
    const uid = userKey.split("-")[2];
    // load the document
    return database
      .collection("Users")
      .doc(uid)
      .get()
      .then((docSnap) => ({ userKey, docSnap }))
      .catch((err) => ({ userKey, error: err }));
  });

  const results = await Promise.allSettled(promises);
  // Read the document.
  results.forEach((res) => {
    if (
      res.status === "fulfilled" &&
      res.value &&
      res.value.docSnap &&
      res.value.docSnap.exists
    ) {
      const { userKey, docSnap } = res.value;
      const location = users[userKey];
      userEmailsTemp[location] = userEmailsTemp[location] || {};
      userEmailsTemp[location][userKey] = docSnap.data().email;
    } else if (res.status === "rejected") {
      console.error("User read rejected:", res.reason);
    }
  });

  setLoadingEmails(false);
  setUserEmails({ ...userEmailsTemp });
  return { ...userEmailsTemp };
}
